import {
    trackEvent,
    TRACKING_EVENT,
    PLATFORM_TYPE,
    TRACKING_PAGE,
} from '@zooplus/tracker-listener';

import {
    SearchBarClickParams,
    TrackableSuggestionType,
    SUGGESTION_TARGET_NAME,
    SUGGESTION_TARGET_VALUE,
} from './types';

export function trackSearchBarClick({
    siteId,
    locale,
}: SearchBarClickParams): void {
    trackEvent({
        event: TRACKING_EVENT.CLICK,
        page: TRACKING_PAGE.GLOBAL,
        detail: {
            platform: PLATFORM_TYPE.WEB,
            locale,
            siteId,
            target: {
                name: 'search_bar',
                id: 'first',
            },
        },
    });
}

type SearchSuggestionClickParams = {
    type: TrackableSuggestionType;
    position: number;
    siteId: number;
    locale: string;
};

export function trackSearchSuggestionClick({
    type,
    position,
    siteId,
    locale,
}: SearchSuggestionClickParams): void {
    trackEvent({
        event: TRACKING_EVENT.CLICK,
        page: TRACKING_PAGE.GLOBAL,
        detail: {
            platform: PLATFORM_TYPE.WEB,
            locale,
            siteId,
            target: {
                name: SUGGESTION_TARGET_NAME[type],
                id: `position_${position + 1}`,
                value: SUGGESTION_TARGET_VALUE[type],
            },
        },
    });
}
